import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/episodes/$episodeUid/",
)({
	beforeLoad({ params }) {
		throw redirect({
			to: "/podcasts/$channelUid/episodes/$episodeUid/details",
			params,
		});
	},
});
